import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IdentificationsService {

  constructor(
    private http: HttpClient
  ) { }

  getResidentialInfo(cpf: string, fingerprint_: string, cep?: string): Observable<any> {
    const query = this.mountGetResidentialInfoQuery(cpf, cep)

    const headers = new HttpHeaders({
      'x-ecomm-fingerprint': fingerprint_,
      ...( !environment.production ? { 'x-dev-access': environment.EcommBffDevAccess } : {} )
    });

    return this.http.get(
      `${environment.ecomBff}/identifications/customer/residential?${query}`,
      { headers }
    );
    // return of(
    //   {
    //     "data": {
    //       "status": "CONECTADO"
    //     },
    //     "error": null
    //   }
    // );
  }

  mountGetResidentialInfoQuery(cpf: string, cep: string): string {
    const document = cpf.replace(/\D+/g, '')
    let zipcode = ''
    if(cep) {
      zipcode = cep.replace(/\D+/g, '')
    }

    let query = `document=${document}`
    if(zipcode != ''){
      query += `&zipcode=${zipcode}`
    }
    
    return query
  }
}
